import React, { useCallback } from 'react'

import { useRouter } from 'next/navigation'

import {
  AppearingWrapper,
  LatestNewsGallery,
  SectionContainer,
} from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Button, Text } from 'Components/UI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'
import { CLUBHOUSE } from 'Constants/Paths'

import { useResponsiveLayout } from 'Hooks'

import { Container } from './styles'

function LatestNewsSection() {
  const { isMobile } = useResponsiveLayout()
  const router = useRouter()

  const handleButtonClick = useCallback(() => {
    router.push(CLUBHOUSE)
  }, [router])

  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container px={LANDING_CONTENT_PX} py={[80, 80, 100]}>
          <SubsectionTitle
            centered
            subtitle="Keep your eye on the ball"
            title="Latest News"
          />

          <Text
            body
            center
            mb={11}
            mt={4}
            regular
            screen16={isMobile}
            screen20={!isMobile}
          >
            With regular updates, news, events and informative blogs.
          </Text>

          <LatestNewsGallery />

          <Button large mt={13} onClick={handleButtonClick}>
            Explore Our Blogs
          </Button>
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default LatestNewsSection
